/**
 * Accepts the text from a seabird data file and appends the key: value meta Object
 * in the file.
 * Returns a new instance of the file.
 */
function appendSeabirdMeta(text, meta) {
  const promise = new Promise(resolve => {
    // Remove, "line 1", "line 2"... from UserHeaderInsert
    let fileText = text.replace(/(\*\*\s+line\s\d+\s*\n)/g, "");

    // If files is missing <UserHeaderInster> tag, add it
    if (!/<\/Headers><UserHeaderInsert>/.test(fileText)) {
      fileText = fileText.replace(
        /(\*END\*)/,
        "* </Headers><UserHeaderInsert>\r\n* <![CDATA[\r\n* ]]>\r\n* </UserHeaderInsert>\r\n$&"
      );
    }

    // Add all key: vals in meta to the UserHeaderInsert
    resolve(
      Object.keys(meta).reduce(
        (result, k) =>
          result.replace(
            /(\*\s+]]>\s*\*\s+<\/UserHeaderInsert>)/m,
            `** ${k}: ${meta[k]}\r\n$&`
          ),
        fileText
      )
    );
  });

  return promise;
}

export default appendSeabirdMeta;
